export enum AutomationResponseCreateAutomationError {
  invalidAutomation = 'invalidAutomation',
}
